export const SELECTION_TYPE = {
  NONE: '',
  TEXT: "text",
  IMAGE: "image",
  TABLE: "table",
  NODE: "node",
  EDGE: "edge",
  MIXED: "mixed", //es mappe: nodi+archi o editor testo+immagine
  ANNOTATION: "annotation",
  MATH: "math",
}


export class SelectionDataDto {
  fromGuid?: string = '';
  selectionType: string = SELECTION_TYPE.NONE;
  fromDocType?: 'editor' | 'map' | 'pdf' | 'todolist' | '' = '';
  toDeep?: boolean = false;

  moduleSelectionDto?: ModuleSelectionDataDto | null = null;

  constructor(
    _selectionType = SELECTION_TYPE.NONE, _fromDocType: 'editor' | 'map' | 'pdf' | 'todolist' | '' = '',
    _moduleSelectionDto: ModuleSelectionDataDto | null = null
  ) {
    this.moduleSelectionDto = _moduleSelectionDto;
    this.fromDocType = _fromDocType;
    this.selectionType = _selectionType;
  }

  public getText(): string {
    return this.moduleSelectionDto?.getText() || '';
  }

  public getImages(): ImageSelectionDataDto[] | null {
    if (this.moduleSelectionDto instanceof EditorSelectionDataDto) {
      return this.moduleSelectionDto.images || null;
    } else if (this.moduleSelectionDto instanceof PDFSelectionDataDto) {
      return this.moduleSelectionDto.annotation ? [this.moduleSelectionDto.annotation] : null;
    }
    else if (this.moduleSelectionDto instanceof MapSelectionDataDto) {
      const mapSelectionData = this.moduleSelectionDto as MapSelectionDataDto;
      if (!mapSelectionData.mapFragment) return null;
      return mapSelectionData?.mapFragment?.nodes?.map((n: any) => {
        //Prende WWW o ltx
        const webOrLatexLink = n.links?.find(
          (link: any) => link.type === 'WWW' || link.type === 'ltx'
        );

        //Prende l'uri
        const altText = webOrLatexLink ? webOrLatexLink.uri : '';

        // Crea la nuova istanza del DTO
        return new ImageSelectionDataDto(
          n.imageBase64,
          n.width ? n.width : undefined,
          n.height ? n.height : undefined,
          altText
        );
      }) ?? null;
    }
    else {
      return null;
    }
  }

  public hasSelection(): boolean {
    return this.selectionType !== SELECTION_TYPE.NONE && this.fromDocType !== '';
  }
}

export abstract class ModuleSelectionDataDto {
  abstract getText(): string;
  moduleTypeDto: string = 'ModuleSelectionDataDto';
}

export class PlainTextSelectionDataDto extends ModuleSelectionDataDto {
  text?: string = '';

  constructor(_text?: string) {
    super();
    this.moduleTypeDto = 'PlainTextSelectionDataDto';
    this.text = _text;
  }

  override getText(): string {
    return this.text || '';
  }
}

export class TodoListSelectionDataDto extends ModuleSelectionDataDto {
  html?: string = '';

  constructor(_html?: string) {
    super();
    this.moduleTypeDto = 'TodoListSelectionDataDto';
    this.html = _html;
  }

  override getText(): string {
    return this.html || '';
  }
}

export class MapSelectionDataDto extends ModuleSelectionDataDto {
  mapFragment?: any;
  mapFragmentText?: string = '';

  constructor(_mapFragment?: any, _mapFragmentText?: string) {
    super();
    this.moduleTypeDto = 'MapSelectionDataDto';
    this.mapFragment = _mapFragment;
    this.mapFragmentText = _mapFragmentText;
  }

  getText(): string {
    return this.mapFragmentText || '';
  }
}
export class EditorSelectionDataDto extends ModuleSelectionDataDto {
  plainText?: string = '';
  html?: string = '';
  sfdt?: any;
  images?: ImageSelectionDataDto[] | null = null;

  constructor(_plainText?: string, _html?: string, _sfdt?: any, _image?: ImageSelectionDataDto[] | null) {
    super();
    this.moduleTypeDto = 'EditorSelectionDataDto';
    this.plainText = _plainText;
    this.html = _html;
    this.sfdt = _sfdt;
    this.images = _image || null;
  }

  override getText(): string {
    return this.plainText || '';
  }
}
export class PDFSelectionDataDto extends ModuleSelectionDataDto {
  text?: string = '';
  annotation?: ImageSelectionDataDto | null = null;
  selectionObject?: any = null;

  constructor(_text?: string, _annotation?: ImageSelectionDataDto | null, _selectionObject?: any) {
    super();
    this.moduleTypeDto = 'PDFSelectionDataDto';
    this.text = _text;
    this.annotation = _annotation;
    this.selectionObject = _selectionObject;
  }

  override getText(): string {
    return this.text || '';
  }
}

export class ImageSelectionDataDto {
  base64: string;
  width: number | undefined;
  height: number | undefined;
  altText: string;

  constructor(_base64: string, _width: number | undefined, _height: number | undefined, _altText: string) {
    this.base64 = _base64;
    this.width = _width;
    this.height = _height;
    this.altText = _altText;
  }
}

export function rehydrateSelectionDataDto(data: any): SelectionDataDto {
  const selectionData = Object.assign(new SelectionDataDto(), data);

  if (data.moduleSelectionDto) {
    switch (data.moduleSelectionDto.moduleTypeDto) {
      case 'PDFSelectionDataDto':
        selectionData.moduleSelectionDto = Object.assign(new PDFSelectionDataDto(), data.moduleSelectionDto);
        break;
      case 'EditorSelectionDataDto':
        selectionData.moduleSelectionDto = Object.assign(new EditorSelectionDataDto(), data.moduleSelectionDto);
        break;
      case 'MapSelectionDataDto':
        selectionData.moduleSelectionDto = Object.assign(new MapSelectionDataDto(), data.moduleSelectionDto);
        break;
      case 'PlainTextSelectionDataDto':
        selectionData.moduleSelectionDto = Object.assign(new PlainTextSelectionDataDto(), data.moduleSelectionDto);
        break;
      case 'TodoListSelectionDataDto':
        selectionData.moduleSelectionDto = Object.assign(new TodoListSelectionDataDto(), data.moduleSelectionDto);
        break;
      default:
        selectionData.moduleSelectionDto = null;
    }
  }

  return selectionData;
}

